import { getOrder } from 'selectors/entities/order/order';
import { orderExpirationService } from 'services/payex/india/orderExpiration';
import type { PayexThunkAction } from 'store/configureStore';

export const fetchOrderExpirationDate =
  (): PayexThunkAction<Promise<string>> => async (_dispatch, getState) => {
    const { id, token } = getOrder(getState());

    if (!id || !token) {
      return Promise.reject(
        new Error('fetchOrderExpirationDate: id and token are required'),
      );
    }

    const { dueAt } = await orderExpirationService.fetch(id, token);

    return dueAt;
  };
